import { render, staticRenderFns } from "./chooseGroup.vue?vue&type=template&id=57d7da61"
import script from "./chooseGroup.vue?vue&type=script&lang=js"
export * from "./chooseGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports